import React from 'react';
import { Box } from '@mui/material';
import { withTranslation } from 'react-i18next';

import {
  Header,
  Tabs,
  ModalContainer,
} from '@core/dashboard/components/PopoverModal';
import { ProfileScreensEnum } from '@components/UserProfileModalNew/interfaces';
import LanguageSelector from './LanguageSelector';

import { ISettings } from './interfaces';
import { useStyles } from './styles';

const SettingsProfile = ({
  onClose,
  setActiveScreen,
  t: translate,
}: ISettings) => {
  const classes = useStyles();

  return (
    <ModalContainer
      header={
        <>
          <Header
            onClose={onClose}
            text={translate('settingsModal.settings')}
            onBack={() => setActiveScreen(ProfileScreensEnum.DEFAULT)}
            isBig
          />
          <Tabs
            active="general"
            onChange={() => {}}
            sx={classes.tabs}
            tabs={[
              { label: translate('settingsModal.general'), value: 'general' },
            ]}
          />
        </>
      }
      isScrollable={true}
      hasTabs
    >
      <Box>
        <LanguageSelector label={translate('settingsModal.language')} />
      </Box>
    </ModalContainer>
  );
};

export default withTranslation()(SettingsProfile);
